module.exports = __webpack_public_path__ + "assets/c30b6810a32de76366df3fb87bd3135b.mp3";